import { ScreenSize } from '@core/models';

export const breakPoints: Record<string, number[]> = {
  Mobile: [300, 768],
  Tablet: [769, 1024],
  Laptop: [1025, 1400],
  Desktop: [1401, 1600],
  XLarge: [1601, 3000],
};

export const emptyScreenSize: ScreenSize = {
  isMobile: false,
  isTablet: false,
  isLaptop: false,
  isDesktop: false,
  isXLarge: false,
};
